






































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: String, default: "" }) public color;
  @Prop({ type: String, default: "53px" }) public height;
  @Prop({ type: String, default: "dark" }) public theme;
  public active = 0;
  public list: any = [
    {
      title: "传奇合作",
      item: [
        {
          itemTitle: "传奇商务阿杜",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881574772",
          qqNumber: "2881574772",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "17717858732",
        },
        // {
        //   itemTitle: "传奇商务小余",
        //   qqIcon: "/static/imgs/qq.png",
        //   qq: "2885654006",
        //   qqNumber: "2885654006",
        //   qqType: 1,
        //   iphoneIcon: "/static/imgs/iphone.png",
        //   iphone: "13738005425",
        // },
        {
          itemTitle: "传奇商务涂涂",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881575411",
          qqNumber: "2881575411",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "19128737404",
        },
        {
          itemTitle: "传奇商务麦芽",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881957402",
          qqNumber: "2881957402",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "18858422063",
        },
        {
          itemTitle: "传奇商务七月",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881575403",
          qqNumber: "2881575403",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "18805607546",
        },
        {
          itemTitle: "996传奇引擎QQ交流群",
          qqIcon: "/static/imgs/qun.png",
          qq: "656631993(5群)",
          qqNumber: "656631993",
          qqType: 2,
        },
        // {
        //   itemTitle: "996传奇引擎lua交流群",
        //   qqIcon: "/static/imgs/qun.png",
        //   qq: "856211842",
        //   qqNumber: "856211842",
        //   qqType: 2,
        // },
        {
          itemTitle: "996传奇引擎2.5D交流群",
          qqIcon: "/static/imgs/qun.png",
          qq: "577342074",
          qqNumber: "577342074",
          qqType: 2,
        },
        {
          itemTitle: "996传奇引擎PC交流群",
          qqIcon: "/static/imgs/qun.png",
          qq: "1007963647",
          qqNumber: "1007963647",
          qqType: 2,
        }
      ]
    },
    {
      title: "传世合作",
      item: [
        {
          itemTitle: "传世商务老史",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881574773",
          qqNumber: "2881574773",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "15897890902",
        },
        {
          itemTitle: "传世商务桃花",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881964490",
          qqNumber: "2881964490",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "18964864298",
        },
        {
          itemTitle: "传世引擎QQ交流群",
          qqIcon: "/static/imgs/qun.png",
          qq: "417640866(2群)",
          qqNumber: "417640866",
          qqType: 2,
        }
      ]
    },
    {
      title: "传奇3合作",
      item: [
        {
          itemTitle: "传奇商务阿杜",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881574772",
          qqNumber: "2881574772",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "17717858732",
        },
        {
          itemTitle: "传奇商务涂涂",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881575411",
          qqNumber: "2881575411",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "19128737404",
        },
        {
          itemTitle: "传奇商务麦芽",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881957402",
          qqNumber: "2881957402",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "18858422063",
        },
        {
          itemTitle: "传奇商务七月",
          qqIcon: "/static/imgs/qq.png",
          qq: "2881575403",
          qqNumber: "2881575403",
          qqType: 1,
          iphoneIcon: "/static/imgs/iphone.png",
          iphone: "18805607546",
        }
      ]
    },
    {
      title: "商务合作",
      item: [
        {
          itemTitle: "合作邮箱",
          qq: "bd@996m2.com",
          qqIcon: "/static/imgs/mailbox.png",
        }
      ]
    }
  ];
  public getUrl(state) {
    if (state == 6) {
      window.open("https://beian.miit.gov.cn/", "_blank");
    }
  }
  public beianClick() {
    window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
  }
  public arouseQQ(state, num) {
    if (state == 1) {
      window.open(
        `mqqwpa://im/chat?chat_type=wpa&uin=${num}&version=1&src_type=web&web_src=bjhuli.com`,
        "_blank"
      );
    }
    if (state == 2) {
      window.open(
        `mqqapi://card/show_pslcard?src_type=internal&version=1&uin=${num}&card_type=group&source=external`,
        "_blank"
      );
    }
    if (state == 3) {
      window.location.href = `tel:${num}`
    }
  }
}
